import React from 'react';
import {NavLink, useParams} from "react-router-dom";
import { useTranslation } from "react-i18next";

interface OrderMainFoodPathProps {
    path: string[];
    selectedCategory: string;
}

const OrderMainFoodPath: React.FC<OrderMainFoodPathProps> = (props) => {
    const { t } = useTranslation();
    const {category, details} = useParams();

    return (
        <div className="orderMainFoodPath__container">
            <div className="orderMainFoodPath__container-path-wrap">
                <div className="orderMainFoodPath__container-path-list-main-item-wrap">
                    <NavLink to="/">{t('categories.mainPage')}</NavLink>
                </div>
                {
                    props.path.map((item, index) => (
                        <div
                            className="orderMainFoodPath__container-path-list-item-wrap"
                            key={index}
                        >
                            {
                                item === "Food" ? (
                                    <>
                                        <span className="orderMainFoodPath__container-path-symbol">{`>`}</span>
                                        <NavLink to="/food">
                                            {t(`categories.food`)}
                                        </NavLink>
                                    </>
                                    ) : (
                                    <div className="orderMainFoodPath__container-path-item-wrap">
                                        {
                                            item !== "" && item !== "All" ? (
                                            <span className="orderMainFoodPath__container-path-symbol">{`>`}</span>
                                            ) : null
                                        }
                                        {
                                            item !== "All" && item !== "Accept order" && item !== "Cart" && (
                                                <div className={`orderMainFoodPath__container-path-item ${item.toLowerCase().replace(/\s/g, "-") === details ? 'active' : ''}`}>
                                                    {
                                                        item !== props.selectedCategory ? (
                                                            <div className="orderMainFoodPath__container-path-item-component">
                                                                {/*<NavLink to={`/food/${props.selectedCategory.toLowerCase().replace(/\s/g, "-")}/${item.toLowerCase().replace(/\s/g, "-")}`}>{order.data.name}</NavLink>*/}
                                                            </div>
                                                        ) : (
                                                            <div className="orderMainFoodPath__container-path-item-component selected">
                                                                <NavLink to={`/food/${item.toLowerCase().replace(/\s/g, "-")}`}>
                                                                    {t(`categories.${item.toLowerCase()}`)}
                                                                </NavLink>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            )
                                        }
                                        {
                                            item === "Cart" && (
                                                <NavLink to={`/cart/${details}`}>
                                                    {t(`categories.${item.toLowerCase()}`)}
                                                </NavLink>
                                            )
                                        }
                                    </div>
                                )
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default OrderMainFoodPath;